// Add your JS customizations here
jQuery(document).ready(function($) {
	new WOW().init();

	$('#testimonials-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
		cssEase: 'linear',
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('#accreditation-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
		cssEase: 'linear',
		adaptiveHeight: true,
	});

	$('#accreditation-slider-mobile').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
		cssEase: 'linear',
		adaptiveHeight: true,
	});

	$('#featured-treatments-slider-mobile').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
		cssEase: 'linear',
		adaptiveHeight: true,
	});

	$('#treatment-videos').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 4000,
		cssEase: 'linear',
		fade: true,
		adaptiveHeight: true,
		prevArrow: '.treatment-video-prev',
		nextArrow: '.treatment-video-next',
	});

	$('#single-treatment-ft-slider').slick({
		slidesToShow: 3,
		slidesToScroll: true,
		swipeToSlide: true,
		infinite: true,
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
		cssEase: 'linear',
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('#single-treatment-rc-slider').slick({
		slidesToShow: 3,
		slidesToScroll: true,
		swipeToSlide: true,
		infinite: true,
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
		cssEase: 'linear',
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('.main-content-repeater .repeater-image').each(function (index) {
		var sliderIndex = index + 1; // Unique index for each slider
		var sliderSelector = '.general-repeater-slider-' + sliderIndex;
		var dotsContainerSelector = '.general-repeater-dots-' + sliderIndex; // Target specific dots container

		$(sliderSelector).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: true,
			appendDots: $(dotsContainerSelector), // Append dots inside the specific div
			arrows: false,
			centerMode: true,
			centerPadding: '0',
		});
	});

	$('.the-team .team-mobile-slider').each(function (index) {
		var sliderIndex = index + 1; // Unique index for each slider
		var sliderSelector = '.team-mobile-repeater-slider-' + sliderIndex;

		$(sliderSelector).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
			centerMode: false,
			centerPadding: '0',
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 771,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	});

	$('.the-team .rel-team-mobile-slider').each(function (index) {
		var sliderIndex = index + 1; // Unique index for each slider
		var sliderSelector = '.rtm-repeater-slider-' + sliderIndex;

		$(sliderSelector).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
			centerMode: false,
			centerPadding: '0',
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 771,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	});

	$('.before-after-slider-wrap').each(function () {
		var $wrap = $(this);
		var $slider = $wrap.find('.before-after-slider');
		var $dots = $wrap.find('.before-after-dots');
		var $counterCurrent = $wrap.find('.before-after-counter__current');
		var hasControls = $wrap.find('.before-after-controls').length > 0;

		if (!$slider.length || $slider.hasClass('slick-initialized')) {
			return;
		}

		function updateBeforeAfterCounter(slick, currentSlide) {
			if (!$counterCurrent.length) {
				return;
			}

			var slideIndex = typeof currentSlide === 'number' ? currentSlide : slick.currentSlide;
			$counterCurrent.text(slideIndex + 1);
		}

		$slider.on('init reInit afterChange', function (event, slick, currentSlide) {
			updateBeforeAfterCounter(slick, currentSlide);
		});

		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: hasControls,
			prevArrow: $wrap.find('.before-after-prev'),
			nextArrow: $wrap.find('.before-after-next'),
			dots: hasControls && $dots.length > 0,
			appendDots: $dots,
			infinite: false,
			speed: 500,
			adaptiveHeight: true,
			fade: true,
			cssEase: 'linear',
			swipe: true,
			touchMove: true,
			accessibility: true
		});
	});



	function equalizeSlideHeights() {

		if ($(window).width() < 991) {
			$('#testimonials-slider .slide').css('height', 'auto');
			return;
		}

		var maxHeight = 0;

		$('#testimonials-slider .slide')
			.css('height', 'auto')
			.each(function () {
				maxHeight = Math.max(maxHeight, $(this).outerHeight());
			});

		$('#testimonials-slider .slide').css('height', maxHeight);
	}

	function initEqualizeSlideHeights() {

		if ($(window).width() < 991) {
			$('#testimonials-slider .slide').css('height', 'auto');
			return;
		}

		equalizeSlideHeights();
	}

	initEqualizeSlideHeights();

	$(window).on('resize', function () {
		initEqualizeSlideHeights();
		syncExpandMenuColumnHeight();
	});

	function header_scroll_active() {
		var st = $(window).scrollTop();
		if (!$('#wrapper-navbar').hasClass('manual-toggle')) {
			if (st > 50) {
				$('#wrapper-navbar').addClass('scroll-active');
			} else {
				$('#wrapper-navbar').removeClass('scroll-active');
			}
		}
	}

	header_scroll_active();
	$(window).on('scroll', header_scroll_active);

	function resetExpandMenuColumnHeight() {
		$('.expand-menu .menu-column').css('min-height', '');
	}

	function syncExpandMenuColumnHeight() {
		resetExpandMenuColumnHeight();

		if (!window.matchMedia('(max-width: 991.98px)').matches) {
			return;
		}

		$('.expand-menu.active').each(function () {
			const $column = $(this).children('.menu-column').first();
			const columnEl = $column.get(0);

			if (!columnEl) {
				return;
			}

			const viewportMin = window.innerHeight;
			const columnRect = columnEl.getBoundingClientRect();
			let maxBottom = 0;
			const $upperSpacer = $column.children('.upper-spacer').first();

			if ($upperSpacer.length) {
				maxBottom = Math.max(maxBottom, $upperSpacer.outerHeight());
			}

			$column.find('.inner-submenu.active').each(function () {
				const submenuRect = this.getBoundingClientRect();
				const bottomRelative = submenuRect.bottom - columnRect.top;

				maxBottom = Math.max(maxBottom, bottomRelative);
			});

			const paddingBottom = parseFloat($column.css('padding-bottom')) || 0;

			$column.css('min-height', `${Math.max(viewportMin, maxBottom + paddingBottom)}px`);
		});
	}

	function setFixedBookingCtaVisible(isVisible) {
		if (window.matchMedia('(max-width: 991.98px)').matches) {
			$('.fixed-bottom-wrapper').toggleClass('is-menu-hidden', !isVisible);
			return;
		}

		$('.fixed-bottom-wrapper').removeClass('is-menu-hidden');
	}

	function setActiveMenu(activeTrigger, activeMenu) {
		// Reset any previously active states
		$('.hamburger-trigger, .treatments-trigger, .conditions-trigger, .about-trigger').removeClass('is-active');
		$('.expand-menu.burger, .expand-menu.treatments, .expand-menu.conditions, .expand-menu.about').removeClass('active');

		$('.expand-menu.treatments .inner-submenu, .expand-menu.conditions .inner-submenu, .expand-menu.about .inner-submenu').removeClass('active');
		$('.menu-item-has-children').removeClass('inner-submenu-active');

		// Activate the clicked menu
		if (activeTrigger && activeMenu) {
			$(activeTrigger).addClass('is-active');
			$(activeMenu).addClass('active');
			$('body').css('overflow', 'hidden');
			$('#wrapper-navbar').addClass('active menu-active');
			setFixedBookingCtaVisible(false);
			window.requestAnimationFrame(syncExpandMenuColumnHeight);
		} else {
			// Deactivate if no trigger/menu is specified
			$('body').css('overflow', '');
			$('#wrapper-navbar').removeClass('active menu-active');
			setFixedBookingCtaVisible(true);
			resetExpandMenuColumnHeight();
		}
	}

	// Burger menu
	$('.hamburger-trigger').click(function () {
		const isActive = $(this).hasClass('is-active');
		setActiveMenu(isActive ? null : this, isActive ? null : '.expand-menu.burger');
	});

	// Treatments menu
	$('.treatments-trigger').click(function () {
		const isActive = $(this).hasClass('is-active');
		setActiveMenu(isActive ? null : this, isActive ? null : '.expand-menu.treatments');

		if ($('.expand-container').hasClass('mobile')) {
			$('.expand-menu.treatments .inner-submenu').removeClass('active');
		}
	});

	// Conditions menu
	$('.conditions-trigger').click(function () {
		const isActive = $(this).hasClass('is-active');
		setActiveMenu(isActive ? null : this, isActive ? null : '.expand-menu.conditions');

		if ($('.expand-container').hasClass('mobile')) {
			$('.expand-menu.conditions .inner-submenu').removeClass('active');
		}
	});

	// About menu
	$('.about-trigger').click(function () {
		const isActive = $(this).hasClass('is-active');
		setActiveMenu(isActive ? null : this, isActive ? null : '.expand-menu.about');

		if ($('.expand-container').hasClass('mobile')) {
			$('.expand-menu.about .inner-submenu').removeClass('active');
		}
	});

	function setNavBookingDropdownOpen($dropdown, isOpen) {
		const $trigger = $dropdown.find('.nav-booking-dropdown__trigger');

		$('.nav-booking-dropdown').not($dropdown).removeClass('is-open');
		$('.nav-booking-dropdown__trigger').not($trigger).attr('aria-expanded', 'false');

		$dropdown.toggleClass('is-open', isOpen);
		$trigger.attr('aria-expanded', isOpen ? 'true' : 'false');
	}

	$('.nav-booking-dropdown__trigger').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $dropdown = $(this).closest('.nav-booking-dropdown');
		const willOpen = !$dropdown.hasClass('is-open');

		setNavBookingDropdownOpen($dropdown, willOpen);
	});

	$('.nav-booking-dropdown__menu').on('click', function (e) {
		e.stopPropagation();
	});

	// Handle clicks on secondary menu items to open or close the inner-submenu
	$('.submenu .menu-item-has-children > a').click(function (e) {
		e.preventDefault(); // Prevent default link action

		let parentItem = $(this).parent(); // Get the parent <li>
		let innerSubmenu = parentItem.find('.inner-submenu').first(); // Find the related inner submenu

		// Check if the clicked item is already active
		const isActive = parentItem.hasClass('inner-submenu-active');

		// Close all other inner submenus
		$('.submenu .inner-submenu').removeClass('active'); // Close all inner submenus
		$('.menu-item-has-children').removeClass('inner-submenu-active'); // Remove active state from all menu items

		if (!isActive) {
			// Mark the clicked item as active and open its submenu
			parentItem.addClass('inner-submenu-active');
			innerSubmenu.addClass('active'); // Show the clicked inner-submenu
		}

		window.requestAnimationFrame(syncExpandMenuColumnHeight);
	});

	$('.treatments-trigger.mobile, .conditions-trigger.mobile, .about-trigger.mobile').click(function () {
		$('.hamburger').addClass('is-active');
	});

	$('.mobile-submenu-return').click(function () {
		// Reset all active states and remove unnecessary classes
		$('.hamburger-trigger, .treatments-trigger, .conditions-trigger, .about-trigger').removeClass('is-active');
		$('.expand-menu.burger, .expand-menu.treatments, .expand-menu.conditions, .expand-menu.about').removeClass('active');
		$('.expand-menu.treatments .inner-submenu, .expand-menu.conditions .inner-submenu, .expand-menu.about .inner-submenu').removeClass('active');
		$('.menu-item-has-children').removeClass('inner-submenu-active');
		$('body').css('overflow', '');

		// Now reactivate the burger menu
		$('.expand-menu.burger').addClass('active');
		$('.hamburger-trigger').addClass('is-active');
		$('#wrapper-navbar').addClass('active menu-active');
	});

	$(".treatment-menu-trigger").click(function () {
		$(".expand-menu.treatments").addClass("active");
	});

	$(document).on("click", function (event) {
		let $target = $(event.target);

		// Define all elements that should NOT trigger menu close
		if ($target.closest(".menu-column, .inner-submenu, .hamburger-trigger, .treatments-trigger, .conditions-trigger, .about-trigger, .nav-booking-dropdown").length) {
			return; // Stop execution to prevent closing
		}

		// Otherwise, close the menu
		setActiveMenu(null, null); // Close all menus
		$(".submenu .inner-submenu").removeClass("active"); // Close all inner submenus
		$(".menu-item-has-children").removeClass("inner-submenu-active"); // Reset active states
		$('.nav-booking-dropdown').removeClass('is-open');
		$('.nav-booking-dropdown__trigger').attr('aria-expanded', 'false');
	});

	$('.close-menu-trigger').on('click', function (e) {
		e.preventDefault();

		// Close all main menus
		$('.hamburger-trigger, .treatments-trigger, .conditions-trigger, .about-trigger')
			.removeClass('is-active');

		$('.expand-menu.burger, .expand-menu.treatments, .expand-menu.conditions, .expand-menu.about')
			.removeClass('active');

		// Close all submenus
		$('.expand-menu .inner-submenu').removeClass('active');
		$('.menu-item-has-children').removeClass('inner-submenu-active');

		// Reset global states
		$('body').css('overflow', '');
		$('#wrapper-navbar').removeClass('active menu-active');
		setFixedBookingCtaVisible(true);
		resetExpandMenuColumnHeight();
	});




	$(".footer-title-mobile-expand").click(function () {
		$(this).closest(".footer-expand-wrapper").find(".footer-title-mobile-expand").toggleClass("active");
		$(this).closest(".footer-expand-wrapper").find(".footer-mobile-menu").toggleClass("active");
	});

	// Parallax — viewport-relative offset + rAF (avoids lag from CSS transition + document scroll math)
	var parallaxRafId = null;

	function parallaxPrefersReducedMotion() {
		return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	}

	function updateParallax() {
		if (parallaxPrefersReducedMotion() || window.innerWidth <= 991) {
			document.querySelectorAll(".parallax-img, .parallax-bg").forEach(function (el) {
				el.style.transform = "";
			});
			return;
		}

		var wh = window.innerHeight;
		var margin = wh * 0.35;
		var imgStrength = 0.1;
		var bgStrength = 0.085;

		document.querySelectorAll(".parallax-img").forEach(function (el) {
			var rect = el.getBoundingClientRect();
			if (rect.bottom < -margin || rect.top > wh + margin) {
				el.style.transform = "";
				return;
			}
			var centerY = rect.top + rect.height / 2;
			var offset = (wh / 2 - centerY) * imgStrength;
			el.style.transform = "translate3d(0, " + offset + "px, 0) scale(1.15)";
		});

		document.querySelectorAll(".parallax-bg").forEach(function (el) {
			var parent = el.parentElement;
			if (!parent) {
				return;
			}
			var rect = parent.getBoundingClientRect();
			if (rect.bottom < -margin || rect.top > wh + margin) {
				el.style.transform = "";
				return;
			}
			var centerY = rect.top + rect.height / 2;
			var offset = (wh / 2 - centerY) * bgStrength;
			el.style.transform = "translate3d(0, " + offset + "px, 0) scale(1.08)";
		});
	}

	function scheduleParallax() {
		if (parallaxRafId !== null) {
			return;
		}
		parallaxRafId = window.requestAnimationFrame(function () {
			parallaxRafId = null;
			updateParallax();
		});
	}

	$(window).on("scroll.parallax resize.parallax load.parallax", scheduleParallax);
	requestAnimationFrame(updateParallax);

	// When any button is clicked
	document.querySelectorAll('.category-btn').forEach(button => {
		button.onclick = function() {
			// Remove 'active' class from all buttons and templates
			document.querySelectorAll('.category-btn').forEach(btn => btn.classList.remove('active'));
			document.querySelectorAll('.category-template').forEach(template => template.classList.remove('active'));

			// Add 'active' class to the clicked button and corresponding template
			this.classList.add('active');
			document.getElementById(this.getAttribute('data-category')).classList.add('active');
		};
	});


	if (window.location.href.includes("scroll=article-list")) {
		const target = $("#article-list");
		if (target.length) {
			setTimeout(function() {
				const offset = target.offset().top - 100; // Adjust for nav height
				$("html, body").animate({ scrollTop: offset }, 500); // Smooth scroll
			}, 500); // Delay ensures content is fully loaded before scrolling
		}
	}

	$('.init-select2 select').select2({
		width: '100%',
		allowClear: true
	});

	const hubspotOverlay = document.getElementById('hubspot-booking-overlay');

	if (hubspotOverlay) {
		const hubspotFormTarget = document.getElementById('hubspot-booking-form-target');
		let hubspotFormLoaded = false;
		let hubspotFormLoading = false;

		function getHubspotConfig() {
			const configRaw = hubspotOverlay.getAttribute('data-hubspot-config');

			if (!configRaw) {
				return null;
			}

			try {
				return JSON.parse(configRaw);
			} catch (error) {
				return null;
			}
		}

		function loadHubspotFormsLibrary() {
			return new Promise(function (resolve, reject) {
				if (window.hbspt && window.hbspt.forms) {
					resolve();
					return;
				}

				const existingScript = document.querySelector('script[src*="js.hsforms.net/forms/embed/v2.js"]');

				if (existingScript) {
					existingScript.addEventListener('load', function () {
						resolve();
					});
					existingScript.addEventListener('error', reject);

					if (window.hbspt && window.hbspt.forms) {
						resolve();
					}

					return;
				}

				const script = document.createElement('script');
				script.src = 'https://js.hsforms.net/forms/embed/v2.js';
				script.charset = 'utf-8';
				script.onload = function () {
					resolve();
				};
				script.onerror = reject;
				document.body.appendChild(script);
			});
		}

		function injectHubspotForm() {
			if (hubspotFormLoaded || hubspotFormLoading || !hubspotFormTarget) {
				return;
			}

			const config = getHubspotConfig();

			if (!config || !config.portalId || !config.formId) {
				return;
			}

			hubspotFormLoading = true;

			loadHubspotFormsLibrary()
				.then(function () {
					window.hbspt.forms.create({
						region: config.region || 'na1',
						portalId: config.portalId,
						formId: config.formId,
						target: '#hubspot-booking-form-target',
					});
					hubspotFormLoaded = true;
				})
				.catch(function () {
					hubspotFormLoading = false;
				});
		}

		function openHubspotOverlay() {
			hubspotOverlay.hidden = false;
			hubspotOverlay.setAttribute('aria-hidden', 'false');
			document.body.classList.add('hubspot-booking-open');
			injectHubspotForm();
		}

		function closeHubspotOverlay() {
			hubspotOverlay.hidden = true;
			hubspotOverlay.setAttribute('aria-hidden', 'true');
			document.body.classList.remove('hubspot-booking-open');
		}

		document.addEventListener('click', function (event) {
			if (event.target.closest('.js-hubspot-booking-trigger')) {
				event.preventDefault();
				openHubspotOverlay();
				return;
			}

			if (event.target.closest('.js-hubspot-booking-close')) {
				event.preventDefault();
				closeHubspotOverlay();
			}
		});

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && !hubspotOverlay.hidden) {
				closeHubspotOverlay();
			}
		});
	}

});
